module.exports = __webpack_public_path__ + "static/media/TD.e99b6682.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TD.svg
// module id = 2271
// module chunks = 7